<template>
    <div class="input-container" :class="label ? 'input-container-with-label' : ''">
        <form-label-title v-if="label" :label="label" :is-required="isRequired" />
        <el-input-number 
            v-model="value"
            class="input-number"
            :placeholder="placeholder"
            :disabled="disabled"
            :size="size"
            :min="min"
            :max="max"
            :step="step"
            pattern="[0-9]"
            title="Numbers only"
            @change="handleChange($event)"
            @keypress.native="handleKeyPress($event)"
        />
        <div class="min-max-container">
            <span v-show="min" class="min-max-text">Min: {{ min }} {{ minAppendText }}</span>
            <span v-show="max" class="min-max-text">Max: {{ max }} {{ maxAppendText }}</span>
        </div>
    </div>
</template>

<script>
import FormLabelTitle from "./FormLabelTitle";

export default {
    components: {
        "form-label-title": FormLabelTitle,
    },
    props: {
        inputValue: {
            type: String | Number
        },
        label: {
            type: String
        },
        placeholder: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: "small"
        },
        min: {
            type: String | Number,
        },
        max: {
            type: String | Number,
        },
        minAppendText: {
            type: String | Number,
        },
        maxAppendText: {
            type: String | Number,
        },
        step: {
            type: String | Number,
        },
        isRequired: {
            type: Boolean
        }
    },
    computed: {
        value: {
            set(val) {
                this.$emit("update:inputValue", val);
            },
            get() {
                return this.inputValue;
            }
        }
    },
    methods: {
        handleChange(value) {
            console.log("handle change", value);
            this.$emit("handleChange", value);
        },
        handleKeyPress(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        }
    },
};
</script>

<style lang="css" scoped>
.input-number{
    width: 100%;
}
.min-max-container{
    display: flex;
    justify-content: space-between;
    margin: var(--space-4);
}
.min-max-text{
    font-size: var(--form-btm-remarks);
    color: var(--description-grey);
}
</style>


// WEBPACK FOOTER //
// src/components/Form/FormInputNumber.vue